<template>
  <div
    class="mx-[10px] lg:mx-10 my-5 bg-primary px-10 py-5 rounded-2xl flex flex-wrap gap-x-10 gap-y-5 justify-between items-center"
  >
    <a
      class="flex flex-row justify-center items-center gap-x-2"
      href="https://www.instagram.com/lima.app/"
      target="_blank"
    >
      <div
        class="bg-fondo w-14 h-14 rounded-full flex justify-center items-center"
      >
        <img src="@/assets/images/instagram.png" alt="" class="w-10 h-10" />
      </div>
      <p>@lima.app</p>
    </a>
    <div
      class="w-fit flex flex-wrap justify-around xl:justify-end items-center gap-x-10 gap-y-5"
    >
      <router-link to="/privacity">POLITICAS DE PRIVACIDAD</router-link>
      <a href="mailto:soporte@milimaapp.com" target="_blank"
        >E-mail: soporte@milimaapp.com</a
      >
      <!-- <a href="tel:+50300000000" target="_blank">Tel.+503 0000-0000</a>
      <a href="https://goo.gl/maps/qePqQV9hoHhEY3FaA" target="_blank"
        >Direccion</a
      > -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
};
</script>

<style></style>
